import React from 'react';
import PropTypes from 'prop-types';

import { Form, FormControl, FormGroup } from 'react-bootstrap-5';

import ManagedInput from 'components/form/managed_input';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class FilterNumberPair extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    filter: PropTypes.object.isRequired,
    label: PropTypes.string,
    maxPlaceholder: PropTypes.string,
    minPlaceholder: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    valueKeys: PropTypes.array.isRequired,
    withIcon: PropTypes.any,
    onChange: PropTypes.func.isRequired,
  };

  static defaultProps = {
    name: '',
  };

  minKey = () => this.props.valueKeys[0];
  maxKey = () => this.props.valueKeys[1];

  minValue = () => this.props.filter[this.minKey()];
  maxValue = () => this.props.filter[this.maxKey()];

  handleMaxChange = (_, event) => {
    this.props.onChange(event, this.maxKey());
  };

  handleMinChange = (_, event) => {
    this.props.onChange(event, this.minKey());
  };

  render() {
    const { label } = this.props;

    return (
      <div className="d-flex flex-column gap-1">
        {label && <Form.Label>{label}</Form.Label>}
        <FormGroup className={`d-flex align-items-center gap-1`}>
          {this.renderMinValue()}
          <span>-</span>
          {this.renderMaxValue()}
        </FormGroup>
      </div>
    );
  }

  renderMinValue() {
    const { name, withIcon, minPlaceholder, placeholder } =
      this.props;
    return (
      <div className="input-group">
        {withIcon && (
          <div className="input-group-text">
            <FontAwesomeIcon className="input-icon" icon={withIcon} />
          </div>
        )}
        <ManagedInput
          className={`input-selection form-control`}
          name={`${name}_min`}
          placeholder={minPlaceholder || placeholder || 'Min'}
          type="number"
          value={this.minValue()}
          onChange={this.handleMinChange}
        />
      </div>
    );
  }

  renderMaxValue() {
    const { name, withIcon, maxPlaceholder, placeholder } = this.props;

    return (
      <div className="input-group">
        {withIcon && (
          <div className="input-group-text">
            <FontAwesomeIcon className="input-icon" icon={withIcon} />
          </div>
        )}
        <ManagedInput
          className={`input-selection form-control`}
          name={`${name}_max`}
          placeholder={maxPlaceholder || placeholder || 'Max'}
          type="number"
          value={this.maxValue()}
          onChange={this.handleMaxChange}
        />
      </div>
    );
  }
}
